import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getPostsByLang } from "../data/posts";
import { useLocale } from "../context/LocaleContext";
import "../styles/root.css";

function Home() {
  const { lang, t } = useLocale();
  const posts = getPostsByLang(lang);
  const featuredPosts = [...posts]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3);

  const impactSlugs = [
    "humanitarian-happening-2022",
    "library-window-to-the-world",
    "consultation-on-senior-services",
  ];

  const impactPosts = impactSlugs
    .map((slug) => posts.find((post) => post.slug === slug))
    .filter(Boolean);

  return (
    <div>
      <Navbar />
      <div className="home-container">
        <h1 className="headline">{t.home.latestNews}</h1>
        <div className="news-grid">
          {featuredPosts.map((post) => (
            <article className="article" key={post.slug}>
              <Link to={`/news/${post.slug}`} className="article-link">
                <img
                  className="article-thumbnail"
                  src={post.mainImage.src}
                  alt={post.mainImage.alt}
                />
                <h2>{post.title}</h2>
                <p>{post.excerpt}</p>
              </Link>
            </article>
          ))}
        </div>
      </div>

      <div className="home-container">
        <h1 className="headline">{t.home.impactHeading}</h1>
        <div className="news-grid">
          {impactPosts.map((post) => (
            <article className="article" key={post.slug}>
              <Link to={`/news/${post.slug}`} className="article-link">
                <img
                  className="article-thumbnail"
                  src={post.mainImage.src}
                  alt={post.mainImage.alt}
                />
                <h2>{post.title}</h2>
                <p>{post.excerpt}</p>
              </Link>
            </article>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Home;
